import { render, staticRenderFns } from "./OrgChildOrganization.vue?vue&type=template&id=9ceeadf4&scoped=true"
import script from "./OrgChildOrganization.vue?vue&type=script&lang=js"
export * from "./OrgChildOrganization.vue?vue&type=script&lang=js"
import style0 from "./OrgChildOrganization.vue?vue&type=style&index=0&id=9ceeadf4&prod&scoped=true&lang=css"
import style1 from "./OrgChildOrganization.vue?vue&type=style&index=1&id=9ceeadf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ceeadf4",
  null
  
)

export default component.exports